import { type FC } from "react"

const Error: FC<{ message: string }> = ({ message }) => (
	<div className="flex flex-col items-center justify-center py-16">
		<div className="mb-4 text-6xl">❌</div>
		<div className="mb-2 text-xl font-semibold text-red-800">Ett fel uppstod</div>
		<div className="mb-4 text-center text-slate-600">{message}</div>
		<button
			type="button"
			onClick={() => window.location.reload()}
			className="transform rounded-lg bg-linear-to-r from-blue-600 to-blue-700 px-6 py-2 font-medium text-white shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:from-blue-700 hover:to-blue-800 hover:shadow-xl"
		>
			Försök igen
		</button>
	</div>
)

export default Error
